// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__13nM8","dark":"Dropdown_dark__20hax"};